import { useState, useEffect } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";

import * as Types from "Types";
import * as api from "api";

import AtomBackdrop from "Components/Atoms/Backdrop";

export type PropsType = any;

const Wrap = styled(AtomBackdrop)<Types.Default>`
   ${(props) => props.css}
`;

function Watcher(props: PropsType) {
   const dispatch = useDispatch();
   const state = useSelector((state: any) => state);

   const [shows, setShows] = useState(false);

   function controller(paramters: any) {
      switch (paramters.status) {
         case api.statuses.pending:
            temp = true;
            break;
         case api.statuses.rejected:
            if (paramters.result) {
               const message = paramters.result === "작가 없음" ? "검색 결과 없음" : paramters.result;
               Swal.fire({
                  icon: "error",
                  title: message,
                  text: "contact@art-map.co.kr로 문의해주세요",
               }).then(() => {
                  dispatch({
                     type: paramters.reset,
                     payload: null,
                  });
               });
            } else if (paramters.message) {
               if (paramters.message === "코드를 입력해주세요 [tempOrderClone: 199]") return;
               Swal.fire({
                  icon: "error",
                  title: paramters.message,
               }).then(() => {
                  dispatch({
                     type: paramters.reset,
                     payload: null,
                  });
               });
            }
            break;
      }
   }

   let temp = false;

   Object.keys(state).forEach(function (k) {
      const current = state[k];

      controller(current);
      current.get && controller(current.get);
      current.insert && controller(current.insert);
      current.update && controller(current.update);
      current.delete && controller(current.delete);
      current.search && controller(current.search);
      current.sync && controller(current.sync);
      // current.set && controller(current.set);
      current.orderClone && controller(current.orderClone);
   });

   useEffect(() => {
      setShows(temp);
   }, [temp]);

   return <Wrap open={shows}></Wrap>;
}

export default Watcher;
